import { Typography } from '@mui/material';
import React from 'react';
import {
  Edit,
  FormTab,
  Labeled,
  NumberField,
  TabbedForm,
  useGetMany,
  useRecordContext,
  useTranslate,
  SimpleForm,
} from 'react-admin';
import { AddPaymentButton } from '../payments/AddPaymentButton';
import { Client, Contract } from '../types';
import { ContractBaseEdit } from './ContractBaseEdit';
import ContractEditToolBar from './ContractEditToolBar';
import ContractLinkedInvoicesList from './ContractLinkedInvoicesList';
import ContractLinkedPaymentsList from './ContractLinkedPaymentsList';

export const ContractEdit = () => {
  return (
    <Edit title={<ContractTitle />} mutationMode="pessimistic">
      <SimpleForm toolbar={<ContractEditToolBar />}>
          <ContractBaseEdit />
      </SimpleForm>
    </Edit>
  );
};

const ContractTitle = () => {
  const translate = useTranslate();
  const record = useRecordContext<Contract>();
  const { data } = useGetMany<Client>(
    'clients',
    {
      ids: [record?.deceased_client_id],
    },

    {
      enabled: !!record?.deceased_client_id,
    }
  );
  const deceased_client_name = data && data[0] ? data[0].name : '';

  return (
    <Typography>
      {translate('resources.contracts.title', {
        id: record ? `#${record.id}` : '',
        deceasedClientName: deceased_client_name,
      })}
    </Typography>
  );
};
